import { render, staticRenderFns } from "./ElasticChatStartup.vue?vue&type=template&id=2a610677&scoped=true&"
import script from "./ElasticChatStartup.vue?vue&type=script&setup=true&lang=js&"
export * from "./ElasticChatStartup.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ElasticChatStartup.vue?vue&type=style&index=0&id=2a610677&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a610677",
  null
  
)

export default component.exports